<template>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ name }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact.formations', params: { contactId: this.contact.id } }">Formations</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>
    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>
    <div class="card-block">
      <h2 class="card-title">Liste des formations</h2>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Titre</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="course of courses | orderBy name">
          <td>{{ course.name }}</td>
          <td class="text-xs-right">
            <button class="btn btn-primary" v-on:click="edit(course)">Modifier</button>
            <button class="btn btn-warning" v-on:click="remove(course)">Supprimer</button>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6">
            <button class="btn btn-primary" v-on:click="create()">Créer une formation</button>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="card-block" v-if="course !== null">
    <hr>
    <h2 class="card-title">{{ editionName }}</h2>
    <validator name="validator">
      <form novalidate>
        <div class="form-group">
          <label for="name">Intitulé de la formation</label>
          <input class="form-control"
            id="name"
            type="text"
            v-model="course.name"
            v-validate:name="{required: required, maxlength: 150}"
          >
          <small class="form-text text-danger" v-if="$validator.name.required">Vous devez indiquer un titre</small>
          <small class="form-text text-danger" v-if="$validator.name.maxlength">Trop long</small>
        </div>
        <div class="form-group">
          <label>Date d'entrée</label>
          <!--
          <date-picker :time.sync="course.start_date" :option="datepickerOptions" ></date-picker>
          <input type="hidden" v-model="course.start_date">
          -->
          <input
            id               = "start_date"
	    class            = "form-control"
            type             = "text"
            v-model          = "course.start_date"
	  >
        </div>
        <div class="form-group">
          <label>Date de sortie</label>
          <!--
          <date-picker :time.sync="course.end_date" :option="datepickerOptions" ></date-picker>
          <input type="hidden" v-model="course.end_date">
          -->
          <input
            id               = "end_date"
	    class            = "form-control"
            type             = "text"
            v-model          = "course.end_date"
	  >
        </div>
        <div class="form-group">
          <label for="name">Organisme de formation</label>
          <input class="form-control"
            id="training_organization"
            type="text"
            v-model="course.training_organization"
          >
          <small class="form-text text-danger" v-if="$validator.training_organization.maxlength">Trop long</small>
        </div>
        <hr>
        <div class="form-group">
          <label>Nature de la formation</label>
          <div v-for="element in course.course_types_list" >
            <switch :value.sync="element.selected" >{{ element.name }}</switch>
          </div>
        </div>
        <div class="form-group">
          <label for="name">Si autre, précision : </label>
          <input class="form-control"
            id="autre_precision"
            type="text"
            v-model = "course.autre_precision"
          >
        </div>
        <hr>
        <div class="form-group">
          <switch :value.sync="course.conventional_objectives">Objectif conventionné</switch>
        </div>
        <div class="form-group">
          <label for="observations">Observations</label>
          <textarea class="form-control" rows="6" cols="40" id="observations" v-model="course.observations"></textarea>
        </div>
        <div class="text-xs-right">
          <button class="btn btn-default" v-on:click.prevent="cancel()">Fermer</button>
          <button class="btn btn-primary" v-on:click.prevent="save()" :class="{ disabled: !$validator.valid }">Enregistrer</button>
        </div>
      </form>
    </validator>
  </div>
</template>
<script>
    // Required for datepicker
    import moment from 'moment'

    // Options for datepicker
//    import { datepickerOptions } from 'src/options/date'

    // Required for datepicker
//    import datePicker from 'vue-datepicker/vue-datepicker-1.vue'

    import { Switch } from 'mint-ui'

    // Vuex
    import { getCourses, addCourse, editCourse, deleteCourse } from 'src/vuex/actions/coursesActions'
    import { getContact } from 'src/vuex/actions/contactActions'
    import { getCourseTypes } from 'src/vuex/actions/courseTypesActions'

    import { contact, courses, courseTypes, coursesRequestError as error } from 'src/vuex/getters'

    export default{
      vuex: {
        getters: {
          courses,
          error,
          contact,
          courseTypes
        },
        actions: {
          getContact,
          getCourses,
          addCourse,
          editCourse,
          deleteCourse,
          getCourseTypes
        }
      },
      validators: {
        list: function (val) {
          return /^[1-9]+$/.test(val)
        }
      },
      data () {
        return {
          course: null,
          courseUpdate: null,
//          datepickerOptions,
          courseTypesList: []
        }
      },
      /*
      watch: {
        'courseTypes': function () {
          if (this.course !== null && this.course.course_types !== undefined) {
            this.updateCourseTypesList()
          }
        }
      },
      */
      computed: {
        name: function () {
          if (Number.isInteger(this.contact.id)) {
            return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
          } else {
            return 'Contact'
          }
        },
        editionName: function () {
          return (this.course !== null && Number.isInteger(this.course.id)) ? 'Edition' : 'Création'
        }
      },
      methods: {
        edit: function (course) {
          course = this.updateCourseTypesList(course)
          this.course = JSON.parse(JSON.stringify(course))
          this.courseUpdate = course
          // courseTypesList n'est pas propagé dans la vue...
          // this.updateCourseTypesList()
        },
        remove: function (course) {
          course = this.updateCourseTypesList(course)
          this.deleteCourse(course)
        },
        create: function () {
          this.course = {}
          this.courseUpdate = null
          this.courseTypesList = []
          this.course = this.updateCourseTypesList(this.course)
        },
        cancel: function () {
          this.course = null
          this.courseUpdate = null
          this.courseTypesList = []
        },
        save: function () {
          // this.course.course_types = this.courseTypesList
          this.course.course_types = this.course.course_types_list
          if (typeof (this.course.start_date) === 'undefined' || this.course.start_date === null || this.course.start_date === '' || this.course.start_date === 'undefined' || this.course.start_date === 'Invalid date') {
            this.course.start_date = ''
          } else {
            this.course.start_date = moment(this.course.start_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          if (typeof (this.course.end_date) === 'undefined' || this.course.end_date === null || this.course.end_date === '' || this.course.end_date === 'undefined' || this.course.end_date === 'Invalid date') {
            this.course.end_date = ''
          } else {
            this.course.end_date = moment(this.course.end_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          // console.log('savecourse ' + this.course.end_date)
          if (this.course !== null) {
            if (Number.isInteger(this.course.id) === true) {
              this.editCourse(this.courseUpdate, this.course)
            } else {
              this.course.contact_id = this.contact.id
              this.addCourse(this.course)
              let contactId = this.contact.id
              let that = this
              setTimeout(function () { that.getCourses(contactId) }, 1000)
            }

            if (this.error === false) {
              this.course = null
            }
          }
        },
        updateCourseTypesList: function (course) {
          let list = []
          // let course = this.course
          this.courseTypes.forEach(function (el) {
            el.selected = false
            if (Array.isArray(course.course_types)) {
              course.course_types.forEach(function (i) {
                if (i.id === el.id || JSON.stringify(i.id) === JSON.stringify(el.id)) {
                  if (i.selected === null || i.selected === undefined || i.selected === true) {
                    el.selected = true
                  }
                }
              })
            }
            list.push(el)
          })
          this.courseTypesList = list
          // courseTypesList n'est pas propagé dans la vue...
          course.course_types_list = list
          return course
        }
      },
//      components: { 'date-picker': datePicker, Switch },
      components: { Switch },
      ready () {
        console.log('ready')
        this.$dispatch('preview-data', [])
        this.getContact(this.$route.params.contactId)
        this.getCourses(this.$route.params.contactId)
        this.getCourseTypes()
      }
    }
</script>



// WEBPACK FOOTER //
// ContactEditFormations.vue?3d5d7674